import React, {Component} from 'react'
import FJUtil from "fj-components/util/FJUtil";
import {connect} from "react-redux";

class FJTimeProgress extends Component {
  render() {
    let {
      currentTime,
      allDuration,
        className,
    } = this.props;

    return (
        <p className={className}>
          {FJUtil.secondToInstant(currentTime, true) + ' / ' + FJUtil.secondToInstant(allDuration, true)}
        </p>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    currentTime: state.timeline.currentTime,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
  }
};

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(FJTimeProgress);
